import { Box } from '@mui/material';
import Images from '../utils/Images';

const SortByComponent = ({ activeFilter, onFilterChange }) => {
  const filters = [
    { name: 'Vegan', value: 'VEGAN', icon: Images.vegan, className: 'vegan' },
    { name: 'Veg', value: 'VEG', icon: Images.veg, className: 'veg' },
    { name: 'Non Veg', value: 'NON-VEG', icon: Images.nonVeg, className: 'non-veg' },
  ];

  return (
    <Box className="sortByComponent">
      <Box className="filters">
        {filters.map((filter, index) => {
          const isActive = activeFilter === filter.value;
          const id = `filter-toggle-${index}`;

          return (
            <Box key={filter.value} className="toggleItem">
              <input
                type="checkbox"
                id={id}
                checked={isActive}
                onChange={() => onFilterChange(filter.value)}
              />

              <label htmlFor={id} className={`toggleSwitch ${filter.className}`}>
                <span className="toggleThumb">
                  <img src={filter.icon} alt={filter.name} />
                </span>
              </label>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default SortByComponent;